import axios from "../../axios";

/**
 * 结业增领
 * @param {*} data
 * @returns
 */
export const jieYeZengLing = data => {
  return axios({
    url: "/stu/stuGraduation",
    method: "post",
    data
  });
};
/**
 * 转校
 * @param {*} data
 * stuId	是	string	学员id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=17629219  20220715
 */
export const changeSchool = data => {
  return axios({
    url: "/stu/transferToSchool",
    method: "post",
    data
  });
};
/**
 * 重置学时
 * @param {*} data
 * stuSchemeId	是	string	课程ID
    stageId	是	string	学时id
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060115  20220622
 */
export const resetClassHour = data => {
  return axios({
    url: "/stu/stuSchemeReset",
    method: "post",
    data
  });
};
/**
 * 解绑微信
 * @param {*} data
 * stuId	是	string	学员ID
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059377  20220420
 */
export const unbindWechat = data => {
  return axios({
    url: "/stu/stuUnBind",
    method: "post",
    data
  });
};
/**
 * 批量解除学员备案绑定
 * @param data [{id, reason}]
 * @param {*} id 学员ID
 * @param {*} reason 解除备案原因
 */
export const batchUnbindRecord = data => {
  return axios({
    url: "/stu/batchDismiss",
    method: "post",
    data
  });
};
/**
 * 学员学时回退
 * @param {Array} [{
 *  stuSchemeId：课程id
 *  backMin: 回退分钟数
 * }]
 * @returns
 */
export const subRollBackClassHour = data => {
  return axios({
    url: "/stu/stuBack",
    method: "post",
    data
  });
};
/**
 * 查询学员回退学时列表
 * @param {*} stuId
 * @returns
 */
export const getRebackClassHourList = data => {
  return axios({
    url: "/stu/stuBackList",
    method: "post",
    data
  });
};
/**
 * 学员重置人脸
 * @param {*} stuId
 */
export const resetFace = data => {
  return axios({
    url: "/stu/restFace",
    method: "post",
    data
  });
};
/**
 * 查询
 */
export const findPage = data => {
  return axios({
    url: "/stu/list",
    method: "post",
    data
  });
};

/**
 * 报名
 */
export const enrolling = data => {
  return axios({
    url: "/stu/enrolling",
    method: "post",
    data
  });
};
/**
 * 修改
 */
export const update = data => {
  return axios({
    url: "/stu/update",
    method: "post",
    data
  });
};
/**
 * 备案
 */
export const report = data => {
  return axios({
    url: "/stu/report/" + data,
    method: "post"
  });
};
/**
 * 备案
 */
export const searchStudent = data => {
  return axios({
    url: "/stu/searchStudent",
    method: "post",
    data
  });
};

/**
 * 备案
 */
export const searchStudentSave = data => {
  return axios({
    url: "/stu/enrollingQuery",
    method: "post",
    data
  });
};
/**
 * 查询学员的信息更具ID
 */
export const detail = data => {
  return axios({
    url: "/stu/detail",
    method: "post",
    data
  });
};
/**
 * 查询学员的目标学时
 */
export const getTargetData = data => {
  return axios({
    url: "/stu/getTargetData",
    method: "post",
    data
  });
};

export const getExport = data => {
  return axios({
    url: "/stu/export",
    method: "post",
    responseType: "blob",
    data
  });
};
export const contract = (id, file) => {
  const data = new FormData();
  data.append('file', file.raw)
  return axios({
    url: '/stu/contract/' + id,
    method: 'post',
    data
  })
}

export const getContract = id => {
  return axios({
    url: '/stu/contract/' + id,
    method: 'get',
    params: {
      type: 1000
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/student/student.js